import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  tasks: [],
};

const { reducer, actions } = createSlice({
  name: 'notification',
  initialState,

  reducers: {
    pushNotitication: (state, { payload }) => {
      // Note:- Add below into tasks.
      // TaskStatusChanged=3
      // TaskRescheduled=4
      // TaskCreated=5
      const tasks = [3, 4, 5];
      if (tasks.includes(payload.notification_type)) {
        state.tasks = [...state.tasks, payload];
        return;
      }
      state.notifications = [...state.notifications, payload];
    },

    clearNotification: (state) => {
      state.notifications = [];
    },
  },
});

export const { pushNotitication, clearNotification } = actions;
export default reducer;
